import { type MultiShadeCharacteristics } from "@jasper/client-models";
import type {
  InputMaybe,
  MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput,
} from "../gql/generated/graphql";

export const getMultiShadeInfo = (
  shadeCharacteristics: MultiShadeCharacteristics
): InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput> => {
  return {
    createMany: {
      data: [
        {
          itemShadeId: shadeCharacteristics.gingivalShade,
          teethShadeSide: "GINGIVAL" as const,
        },
        {
          itemShadeId: shadeCharacteristics.baseShade,
          teethShadeSide: "BASE" as const,
        },
        {
          itemShadeId: shadeCharacteristics.incisalShade,
          teethShadeSide: "INCISAL" as const,
        },
      ],
    },
  };
};
